import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { CheckoutProvider } from 'src/sections/customer/checkout/context';

import AdminOrAgentGuard from 'src/auth/guard/admin-agent-guard';

import AdminAgentOrCusotmerGuard from 'src/auth/guard/admin-agent-customer-guard';

import { paths } from '../paths';

// ----------------------------------------------------------------------
const CatalogShopPage = lazy(() => import('src/pages/customer/catalog'));

// client order
const ClientOrdersPage = lazy(() => import('src/pages/admin/client-order/list'));
const ClientOrderCreatePage = lazy(() => import('src/pages/admin/client-order/new'));
const ClientOrderEditPage = lazy(() => import('src/pages/admin/client-order/edit'));
const ClientOrderDetailsPage = lazy(() => import('src/pages/admin/client-order/details'));

// Agents
const AgentsListPage = lazy(() => import('src/pages/admin/agent/list'));

// clients
const ClientListPage = lazy(() => import('src/pages/admin/client/list'));
const ClientCreatePage = lazy(() => import('src/pages/admin/client/new'));
const ClientDetailsPage = lazy(() => import('src/pages/admin/client/details'));

// agent-specific pages
const AgentDashboardPage = lazy(() => import('src/pages/agent/dashboard'));
const AgentClientDetailPage = lazy(() => import('src/pages/agent/client-detail'));
// ----------------------------------------------------------------------
export const agentRoutes = [
  {
    element: (
      <AuthGuard>
        <CheckoutProvider>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </CheckoutProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.customer.catalog,
        element: (
          <AdminAgentOrCusotmerGuard>
            <CatalogShopPage />
          </AdminAgentOrCusotmerGuard>
        ),
      },
      {
        path: paths.admin.orderTypes.clientOrders.root,
        element: (
          <AdminOrAgentGuard>
            <ClientOrdersPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.orderTypes.clientOrders.new,
        element: (
          <AdminOrAgentGuard>
            <ClientOrderCreatePage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.orderTypes.clientOrders.edit(':order_code'),
        element: (
          <AdminOrAgentGuard>
            <ClientOrderEditPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.orderTypes.clientOrders.details(':order_code'),
        element: (
          <AdminOrAgentGuard>
            <ClientOrderDetailsPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.agents.root,
        element: (
          <AdminOrAgentGuard>
            <AgentsListPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.clients.root,
        element: (
          <AdminOrAgentGuard>
            <ClientListPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: paths.admin.clients.new,
        element: (
          <AdminOrAgentGuard>
            <ClientCreatePage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: `${paths.admin.clients.root}/:slug`,
        element: (
          <AdminOrAgentGuard>
            <ClientDetailsPage />
          </AdminOrAgentGuard>
        ),
      },
      {
        path: 'agent',
        element: (
          <AdminOrAgentGuard>
            <Outlet />
          </AdminOrAgentGuard>
        ),
        children: [
          { path: 'dashboard', element: <AgentDashboardPage /> },
          { path: 'clients/:slug', element: <AgentClientDetailPage /> },
        ],
      },
    ],
  },
];
